import { Button } from '@cdl/heartbeat-react';
import { useDispatch, useSelector } from 'react-redux';
import { SINGLE_LEAD_STRIP_ID } from './SingleLeadPlot';
import { TagConfig } from '../../wave/types/tag.type';
import { WaveType } from '../../wave/types/wave.type';
import { noiseTagFilterSelector } from '../selectors/strip.selectors';
import * as stripActions from '../../plot/actions/strip.actions';

interface Props {
  tag: TagConfig;
}

export const TagButton = ({ tag }: Props) => {
  const dispatch = useDispatch();
  const tagLabel = tag.tags[Object.keys(tag.tags)[0] as WaveType]?.[0];
  const selectedTagFilter = useSelector(
    noiseTagFilterSelector(SINGLE_LEAD_STRIP_ID),
  );
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    dispatch(
      stripActions.update({
        stripId: SINGLE_LEAD_STRIP_ID,
        strip: {
          noiseTagFilter: tagLabel,
        },
      }),
    );
  };
  return (
    <Button
      variant='secondary'
      size='xs'
      isActive={tagLabel === selectedTagFilter}
      fontSize='.8rem'
      onClick={handleClick}
    >
      {tag.name}
    </Button>
  );
};
